module.exports = ".myForm {\r\n  padding: 20px;\r\n  margin: 20px;\r\n}\r\n"